import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#F5F5F5] text-[#1F2937] py-10">
      <div className="max-w-4xl mx-auto px-5 bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-[#4F46E5] text-4xl font-bold mb-5 pb-3 border-b-2 border-[#E5E7EB]">Terms and Conditions</h1>
        <span className="text-sm text-[#6B7280] block mb-5">Effective Date: October 22, 2025</span>

        <p className="mb-6 text-[#4B5563] leading-relaxed">
          Welcome to RetireProApp, operated by Sfumato Ventures. These Terms govern your access to and use of the RetireProApp website and mobile application (the "Service"). By accessing or using the Service, you agree to be bound by these Terms.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">1. Non-Advisory and Educational Disclaimer</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          <strong>RetireProApp is a software planning tool and NOT a financial advisor, broker, or tax consultant.</strong>
        </p>
        <ul className="mb-6 space-y-3 text-[#4B5563] leading-relaxed">
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">•</span>
            <span>The data, projections, simulations (including Monte Carlo), and reports generated by the Service are for <strong>informational and educational purposes only</strong>.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">•</span>
            <span>The Service does not provide personalized investment, tax, legal, or financial advice.</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-[#1F2937] font-semibold">•</span>
            <span>You should consult with a qualified professional before making any financial decisions based on the information provided by the Service.</span>
          </li>
        </ul>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">2. User Obligations</h2>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          You agree to use the Service only for lawful purposes and warrant that all data you provide is accurate to the best of your knowledge. You are responsible for maintaining the confidentiality of your account information.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">3. Data Accuracy and Assumptions</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          The accuracy of the Service's output is contingent upon the accuracy of the data you input and the underlying financial assumptions you select (e.g., inflation rate, expected rate of return, etc.).
        </p>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          <strong>Sfumato Ventures assumes no responsibility or liability for any errors or omissions</strong> in the results generated due to inaccurate user data or unrealistic market assumptions.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">4. Intellectual Property</h2>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          The Service, its original content, features, and functionality are and will remain the exclusive property of Sfumato Ventures and its licensors.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">5. Termination</h2>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          We may terminate or suspend your account immediately, without prior notice or liability, if you breach the Terms.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">6. Governing Law and Jurisdiction</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">
          These Terms shall be governed and construed in accordance with the laws of <strong>India</strong>, without regard to its conflict of law provisions.
        </p>
        <p className="mb-6 text-[#4B5563] leading-relaxed">
          Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in <strong>Bengaluru, Karnataka, India</strong>.
        </p>

        <h2 className="text-[#4F46E5] text-2xl font-bold mt-8 mb-4">7. Contact Information</h2>
        <p className="mb-4 text-[#4B5563] leading-relaxed">For any questions regarding these Terms, please contact us:</p>
        <p className="mb-2 text-[#4B5563] leading-relaxed">
          <strong>Operator:</strong> Sfumato Ventures
        </p>
        <p className="mb-2 text-[#4B5563] leading-relaxed">
          <strong>Address:</strong> 553, 5th Main AGS Layout, Bengaluru, Karnataka, India
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          <strong>Email:</strong> support@retireproapp.com
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
